import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import CheckBox from '~/components/layout/CheckBoxCustom';
import ContactIcon from '@material-ui/icons/ContactsOutlined';
import CloseIcon from '@material-ui/icons/Close';
import { useSelector } from 'react-redux';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { Form as BootstrapForm } from 'react-bootstrap';
import formatCnpj from '@brazilian-utils/format-cnpj';
import moment from 'moment';

import {
  BackIcon,
  CloseIconContainer,
  Background,
  MainContainer,
  Title,
  Textfield,
  ErrorMessage,
  Label,
  LightLabel,
  CheckBoxScrollList,
  CheckBoxList,
  PhoneInput,
} from './styles';
import '~/components/styles/Global.css';
import api from '~/services/api';
import HeaderMobile from '~/components/layout/HeaderOld';
import Loading from '~/components/layout/Loading';
import back from '~/assets/images/arrow.svg';
import { isDashboardVendasCoreAllowed } from '~/config/dashboardVendas';

const roleVisibleForCore = role =>
  role.name !== 'DASHBOARD_VENDAS' || isDashboardVendasCoreAllowed();

export default function Employee({ employeeData, setShowModal }) {
  const [loadingPage, setLoadingPage] = useState(true);
  const [roles, setRoles] = useState([]);
  const [stores, setStores] = useState([]);
  const economicGroupReducer = useSelector(state => state.economicGroupReducer);
  const [phoneMaskManipulator, setPhoneMaskManipulator] =
    useState('(99) 9999-9999');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [ownerName, setOwnerName] = useState('');

  const getStores = () => {
    let storesList = economicGroupReducer.stores;
    storesList = storesList.map(store => {
      store.checked = false;
      return store;
    });

    employeeData.storesAccess.map(store => {
      storesList.map(item => {
        if (store.storeId === item.storeId) {
          item.checked = true;
          return item;
        }
      });
      return '';
    });

    setStores(storesList);
  };

  const getRoles = () => {
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('access_token'),
    };
    const parameters = {
      method: 'GET',
      headers: header,
    };
    const url = `/residential/store/v1/roles?_limit=100`;
    api
      .get(url, parameters)
      .then(res => {
        let rolesList = [];
        rolesList = res.data;
        rolesList = rolesList.map(role => {
          role.checked = false;
          role.nameFiltered = filterRoleName(role.name);
          return role;
        });

        employeeData.roles.map(role => {
          rolesList.map(item => {
            if (role.name === item.name) {
              item.checked = true;
              return item;
            }
          });
        });

        setRoles(rolesList);
      })
      .catch(err => {
        const erro = err.response;
        if (erro) {
          const message = err.response.data.message;
          if (erro.status !== 401) {
            toast.error(message);
          }
        } else {
          if (err.response.status !== 401) {
            toast.error('Ocorreu um erro interno na aplicação');
          }
        }
      });
  };

  const filterRoleName = roleName => {
    switch (roleName) {
      case 'BOLETOS': {
        return 'Boletos';
      }
      case 'HUB': {
        return 'HUB';
      }
      case 'MARKETING': {
        return 'Marketing';
      }
      case 'NOTAS_FISCAIS': {
        return 'Notas Fiscais';
      }
      case 'PEDIDO_DE_ABASTECIMENTO': {
        return 'Pedido de Abastecimento';
      }
      case 'STATUS_DO_PEDIDO': {
        return 'Status do Pedido';
      }
      case 'TREINAMENTOS': {
        return 'Treinamentos';
      }
      case 'VALE_GAS': {
        return 'Vale Gás';
      }
      case 'DESAFIO_LAPIDAR': {
        return 'Desafio Lapidar';
      }
      case 'TROCAS': {
        return 'Trocas';
      }
      case 'CONSULTOR_COMERCIAL': {
        return 'Consultor comercial';
      }
      case 'DASHBOARD_VENDAS': {
        return 'Painel de Metas';
      }
      default: {
        return roleName;
      }
    }
  };

  useEffect(() => {
    getRoles();
    getStores();
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('access_token'),
    };
    const parameters = {
      method: 'POST',
      headers: header,
    };
    const url = `residential/store/v1/users/${employeeData.ownerid}/contacts`;
    api.get(url, parameters).then(res => setOwnerName(res.data[0].name));
    handleGetPhone();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let allApisReturned = true;

    if (stores.length < 1 || roles.length < 1) {
      allApisReturned = false;
    }

    if (allApisReturned === true) {
      setLoadingPage(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stores, roles]);

  const handleGetPhone = () => {
    let phone;
    let email;
    employeeData.contacts.map(item => {
      if (item.contactType === 'PHONE') {
        phone = item.contact;
      } else {
        email = item.contact;
      }
    });

    if (phone.length > 10) {
      setPhoneMaskManipulator('(99) ?9999-9999');
    } else {
      setPhoneMaskManipulator('(99) 9999-9999?');
    }

    setEmail(email);
    setPhone(phone);
  };

  const handlePhoneMaskManipulator = phoneValue => {
    if (phoneValue.target.value.length > 14) {
      setPhoneMaskManipulator('(99) ?9999-9999');
    } else {
      setPhoneMaskManipulator('(99) 9999-9999?');
    }
  };

  const validatePhone = value => {
    let error;
    value = value.split('_').join('');
    value = value.split(' ').join('');
    value = value.split('-').join('');
    value = value.split('(').join('');
    value = value.split(')').join('');
    if (!value) {
      error = 'Insira o celular';
    }
    if (!/[^\d-.\/]/.test(value)) {
      const numbers = value.replace(/[^\d]/g, '');
      if (numbers.length > 0 && numbers.length < 10) {
        error = 'Insira um celular válido';
      }
    }
    return error;
  };

  const filterCleanPhone = aphone => {
    let newPhone = aphone.replace(/[^0-9.]/g, '');
    newPhone = newPhone.length === 10 ? `${newPhone}0` : newPhone;
    return newPhone;
  };

  const SignUpSchema = Yup.object().shape({
    name: Yup.string().required('Preencha o Nome'),
    phone: Yup.string().required('Insira o celular'),
    mail: Yup.string()
      .email('Insira um e-mail válido')
      .required('Preencha o e-mail'),
  });

  const formSubmit = values => {
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('access_token'),
    };
    const parameters = {
      method: 'POST',
      headers: header,
    };
    const body = {
      name: values.name,
      phone: filterCleanPhone(values.phone),
      roles: onlySelectedRoles(roles),
      stores: onlySelectedStores(stores),
    };
    const url = `residential/store/v1/users/${employeeData.ownerid}/employees/${employeeData.userId}`;
    api
      .patch(url, body, parameters)
      .then(res => {
        if (res.status === 204) {
          toast.success('Usuário atualizado com sucesso');
          document.location.reload(true);
        }
      })
      .catch(err => {
        const erro = err.response;
        if (erro) {
          const message = err.response.data.message;
          if (erro.status !== 401) {
            toast.error(message);
          }
        } else {
          if (err.response.status !== 401) {
            toast.error('Ocorreu um erro interno na aplicação');
          }
        }
      });
  };

  const getContactId = location => {
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('access_token'),
    };

    const parameters = {
      method: 'GET',
      headers: header,
    };

    const url = `${location}/contacts?contact-type=EMAIL`;

    api
      .get(url, parameters)
      .then(res => {
        if (res.data.length > 0) {
          sendToken(location, res.data[0].contactId);
        }
      })
      .catch(err => {
        const erro = err.response;
        if (erro) {
          const message = err.response.data.message;
          if (erro.status !== 401) {
            toast.error(message);
          }
        } else {
          if (err.response.status !== 401) {
            toast.error('Ocorreu um erro interno na aplicação');
          }
        }
      });
  };

  const sendToken = (location, contactId) => {
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('access_token'),
    };

    const parameters = {
      method: 'POST',
      headers: header,
    };

    const body = {
      tokenType: 'REGISTER',
      contactId: contactId,
      url: process.env.REACT_APP_URL + 'senha-funcionario',
    };

    const url = `${location}/tokens`;

    api
      .post(url, body, parameters)
      .then(res => {
        toast.success('Cadastro realizado com sucesso');
        backPage();
      })
      .catch(err => {
        const erro = err.response;
        if (erro) {
          const message = err.response.data.message;
          if (erro.status !== 401) {
            toast.error(message);
          }
        } else {
          if (err.response.status !== 401) {
            toast.error('Ocorreu um erro interno na aplicação');
          }
        }
      });
  };

  const onlySelectedRoles = list => {
    return list
      .filter(item => {
        if (item.checked === true) {
          return true;
        } else {
          return false;
        }
      })
      .map(item => {
        return { name: item.name };
      });
  };

  const onlySelectedStores = list => {
    return list
      .filter(item => {
        if (item.checked === true) {
          return true;
        } else {
          return false;
        }
      })
      .map(item => {
        return {
          storeId: item.storeId,
          name: item.name,
        };
      });
  };

  const backPage = () => {
    setShowModal(false);
  };

  const HeaderComponent = () => (
    <>
      <HeaderMobile />
      <CloseIconContainer onClick={backPage}>
        <CloseIcon />
      </CloseIconContainer>
      <BackIcon onClick={backPage}>
        <img src={back} alt="Ícone para voltar" />
      </BackIcon>
    </>
  );

  return (
    <Background>
      {loadingPage ? (
        <>
          <HeaderComponent />
          <Loading />
        </>
      ) : (
        <>
          <HeaderComponent />
          <MainContainer>
            <Title>
              <ContactIcon fontSize="large" />
              Detalhes do usuário
            </Title>
            <Formik
              initialValues={{
                name: employeeData.contacts[0].name,
                mail: email,
                phone: phone,
              }}
              onSubmit={values => {
                formSubmit(values);
              }}
            >
              {({ handleChange, handleBlur, values, errors, touched }) => (
                <Form autocomplete="off">
                  <BootstrapForm.Group controlId="name">
                    <Label>Nome completo</Label>
                    <Field
                      render={({ field }) => {
                        return (
                          <Textfield
                            id="name"
                            type="text"
                            label="Nome completo"
                            arial-label="Nome completo"
                            aria-required
                            errorCondition={errors.name && touched.name}
                            errorMessage={errors.name}
                            title="Nome completo"
                            onBlur={handleBlur}
                            placeholder="Nome completo"
                            disabled
                            value={values.name}
                          />
                        );
                      }}
                      name="name"
                    />
                    {errors.name && touched.name ? (
                      <ErrorMessage>{errors.name}</ErrorMessage>
                    ) : null}
                  </BootstrapForm.Group>
                  <BootstrapForm.Group controlId="mail">
                    <Label>E-mail</Label>
                    <Field
                      render={({ field }) => {
                        return (
                          <Textfield
                            id="mail"
                            type="text"
                            label="E-mail"
                            arial-label="E-mail"
                            aria-required
                            errorCondition={errors.mail && touched.mail}
                            errorMessage={errors.mail}
                            title="E-mail"
                            onBlur={handleBlur}
                            placeholder="E-mail"
                            disabled
                            value={values.mail}
                          />
                        );
                      }}
                      name="mail"
                    />
                    {errors.mail && touched.mail ? (
                      <ErrorMessage>{errors.mail}</ErrorMessage>
                    ) : null}
                  </BootstrapForm.Group>
                  <BootstrapForm.Group controlId="phone">
                    <Label>Celular</Label>
                    <Field
                      render={({ field }) => {
                        return (
                          <PhoneInput
                            id="phone"
                            mask={phoneMaskManipulator}
                            maskChar={null}
                            formatChars={{ 9: '[0-9]', '?': '[0-9]' }}
                            className="inputPhone"
                            type="text"
                            label="Celular"
                            arial-label="Celular"
                            aria-required
                            errorCondition={errors.phone && touched.phone}
                            errorMessage={errors.phone}
                            title="Celular"
                            onBlur={handleBlur}
                            placeholder="Celular"
                            disabled
                            value={values.phone}
                            onChange={e => {
                              handleChange(e);
                              handlePhoneMaskManipulator(e);
                            }}
                          />
                        );
                      }}
                      validate={validatePhone}
                      name="phone"
                    />
                    {errors.phone && touched.phone ? (
                      <ErrorMessage>{errors.phone}</ErrorMessage>
                    ) : null}
                  </BootstrapForm.Group>
                  <BootstrapForm.Group
                    controlId="revendas"
                    className="checkboxGroup"
                  >
                    <LightLabel>Atribuir revenda</LightLabel>
                    <CheckBoxScrollList>
                      {stores.map(store => (
                        <CheckBox
                          name={store.name}
                          checked={store.checked}
                          className="checkbox"
                          label={`${store.name} - ${formatCnpj(
                            store.storeDocument,
                          )}`}
                          title={`${store.name} - ${formatCnpj(
                            store.storeDocument,
                          )}`}
                        />
                      ))}
                    </CheckBoxScrollList>
                  </BootstrapForm.Group>
                  <BootstrapForm.Group
                    controlId="acessroles"
                    className="checkboxGroup"
                  >
                    <LightLabel>Permissões de acesso</LightLabel>
                    <CheckBoxList>
                      {roles.filter(roleVisibleForCore).map(role => (
                        <CheckBox
                          name={role.nameFiltered}
                          className="checkboxList"
                          checked={role.checked}
                          label={role.nameFiltered}
                          title={`${role.nameFiltered} - ${role.description}`}
                        />
                      ))}
                    </CheckBoxList>
                  </BootstrapForm.Group>
                </Form>
              )}
            </Formik>
            <LightLabel className="mt-4 mb-2">Mais detalhes</LightLabel>
            <div className="w-100 d-flex align-items-center justify-content-start mb-4">
              <div className="mr-5">
                <b style={{ fontSize: 14 }}>Criado por:</b>
                <br />
                <span style={{ fontSize: 14, color: '#808080' }}>
                  {ownerName}
                </span>
              </div>
              <div>
                <b style={{ fontSize: 14 }}>Data de cadastro:</b>
                <br />
                <span style={{ fontSize: 14, color: '#808080' }}>
                  {moment(employeeData.createdDate).format('DD/MM/YYYY')}
                </span>
              </div>
            </div>
          </MainContainer>
        </>
      )}
    </Background>
  );
}
